import React, { FC, useEffect, useState } from 'react'
import { NavLink, useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { postMeetingResponse,
  postMeetingOwnerResponse,
  deleteMeeting } from '../../../api/api'

import Loading from '../../../Components/loading/Loading'

import './styles.scss'
import { Routes } from '../../../routing/routes'
import { ApiResponse, Availability, Invitee, MeetingStatus } from '../../../types/plann3r'
import MeetingAvailabilities from '../../../Components/availabilities/MeetingAvailabilities'
import { requestAvailabilities } from '../../../store/availabilities/actions'
import { Plann3rStore } from '../../../store/types'
import { requestCurrentMeetings, requestPastMeetings } from '../../../store/meeting-management/actions'
import { convertDateToLocalTime } from '../../../utils/general'

const MeetingDetails : FC = () => {
  const dispatch = useDispatch()
  const his = useHistory()
  const { meetingId } = useParams<{ meetingId: string }>()

  const [showAvailabilities, setshowAvailabilities] = useState(false)
  const [showButtons, setshowButtons] = useState(true)
  // const [declined, setdeclined] = useState(false)
  // const [responseReceived, setresponseReceived] = useState(true)
  // const [isFetching, setisFetching] = useState(false)

  const { availabilities } = useSelector((state: Plann3rStore) => state.availabilities)
  const strings = useSelector((state: Plann3rStore) => state.languages.strings.meeting.meetingdetails)
  const { current, pending, history } = useSelector((state: Plann3rStore) => state.meetingManagement)

  const meeting = [...pending.meetings, ...current.meetings, ...history.meetings ].find((meeting) => (meeting.id === parseInt(meetingId)))
  
  useEffect(() => {
    if (!meeting) {
      dispatch(requestCurrentMeetings())
      dispatch(requestPastMeetings())
    }
    dispatch(requestAvailabilities(meetingId))

    document.body.scrollTop = 0 // For Safari
    document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
  }, [dispatch, meetingId, meeting])

  const deleteMeetingClicked = async () => {
    const r = confirm(strings.confirm_deletion)
    if (r) {
      const response = await deleteMeeting({ meeting_id: meetingId })

      if (response.success) {
        his.push(Routes.MY_MEETINGS)
      } else {
        alert(strings.deletion_error)
      }
    }
  }

  const handleMeetingResponseReceived = (response: ApiResponse) => {
    if (response.success) {
      his.push(Routes.MY_MEETINGS)
      dispatch(requestCurrentMeetings())
      dispatch(requestPastMeetings())
      setshowAvailabilities(false)
    } else {
      alert('Oops, something went wrong.')
      setshowButtons(true)
    }
  }

  const sendResponse = async (
    status: boolean,
    isOwner: boolean,
    includeAvailabilities: boolean,
  ) => {
    // if (!status) setdeclined(true)

    setshowButtons(false)

    const meeting_response_info = {
      meeting_response: status,
      meeting_id: meetingId,
      availabilities:
        includeAvailabilities && availabilities && availabilities.length > 0
          ? JSON.stringify(
            availabilities
              .filter((availability: Availability) => {
                return availability.selected === true
              })
              .map((availability: Availability) => {
                return {
                  start: availability.start,
                  end: availability.end,
                }
              }),
          )
          : '',
    }

    if (isOwner) {
      handleMeetingResponseReceived(await postMeetingOwnerResponse(meeting_response_info))
    } else {
      handleMeetingResponseReceived(await postMeetingResponse(meeting_response_info))
    }
  }

  if (meeting) {
    let description = null
    const fields_info = []

    const fields = meeting['page-fields']
    if (fields) {
      for (const property in fields) {
        if (property in fields) {
          fields_info.push(
            <span>
              {property}:<em>{fields[property]}</em>
              <br />
            </span>,
          )
        }
      }
      description = (
        <p className="info-item">
          <strong>{strings.description}</strong>
          <br />
          {fields_info}
        </p>
      )
    }

    return (
      <div className="meeting-details">
        <div className="inner-meeting-details plann3rform">
          <NavLink to="/my-meetings" className="link-to-my-meetings">
            <span className="mr-2 text-gray-700">
              Close
            </span>
          </NavLink>
          <h2 className="title is-3">
            <span>{meeting.subject}</span>
            {meeting.status === 'declined' && (
              <div style={{ display: 'inline-block' }}>
                <span>&nbsp;–&nbsp;</span>
                <span style={{ color: 'indianred' }}>{strings.declined}</span>
              </div>
            )}
          </h2>

          {meeting.picked_moment && (
            <div className="meeting-picked-option">
              <div className="">
                <div className="meeting-picked-details">
                  <p className="meeting-picked-option-date is-3 title">
                    <small>
                      {convertDateToLocalTime(meeting.picked_moment.start)} &ndash; {convertDateToLocalTime(meeting.picked_moment.end)}
                    </small>
                  </p>
                </div>
              </div>
            </div>
          )}

          {showButtons &&
            !meeting.isOwner &&
            meeting.invitees.find(
              (invitee: Invitee) => invitee.id === meeting.receiver,
            )?.status !== MeetingStatus.DECLINED &&
            meeting.invitees.find(
              (invitee: Invitee) => invitee.id === meeting.receiver,
            )?.status !== MeetingStatus.CONFIRMED && (
            <div className="buttons">
              <div>
                <button
                  onClick={() => sendResponse(true, false, false)}
                  className="button is-primary"
                >
                  {strings.accept}
                </button>
                <button
                  onClick={() => sendResponse(false, false, false)}
                  className="button is-primary is-outlined"
                >
                  {strings.decline}
                </button>
              </div>
            </div>
          )}

          {!meeting.isOwner && (
            <p>
              <strong>{strings.invited_by}</strong>
              {meeting.owner_firstName} {meeting.owner_lastName}{' '}
            </p>
          )}

          {showButtons &&
            meeting.isOwner &&
            meeting.owner_has_to_accept &&
            !meeting.picked_moment && (
            <div className="buttons">
              <div>
                {meeting.page_id === 0 && (
                  <button
                    onClick={() => sendResponse(true, true, false)}
                    className="button is-primary"
                  >
                    {strings.accept}
                  </button>
                )}
                <button
                  onClick={() => {
                    setshowAvailabilities(true)
                    setshowButtons(false)
                  }}
                  className="button is-primary"
                >
                  {strings.accept_manually}
                </button>
                <button
                  onClick={() => sendResponse(false, true, false)}
                  className="button is-primary is-outlined"
                >
                  {strings.decline}
                </button>
              </div>
            </div>
          )}

          {meeting.isOwner && showAvailabilities && (
            <div>
              <MeetingAvailabilities
                onConfirm={() => sendResponse(true, true, true)}
                invitees={meeting.invitees}
              />
            </div>
          )}

          <hr />

          {meeting.isOwner && (
            <p className="info-item">
              <strong>{strings.created_on + ': '}</strong>
              <br />
              {convertDateToLocalTime(meeting.created_at)}
            </p>
          )}

          {!meeting.virtual && (
            <p className="info-item">
              <strong>{strings.location}</strong>
              <br />
              {meeting.location}
            </p>
          )}

          {meeting.virtual && (
            <p className="info-item">
              <strong>{strings.virtual_meeting}</strong>
            </p>
          )}

          {description}

          <hr />

          {showButtons && meeting.isOwner && (
            <div className="buttons">
              <button
                className="button is-danger is-outlined float-right"
                onClick={() => {
                  deleteMeetingClicked()
                }}
              >
                {strings.delete}
              </button>
            </div>
          )}
        </div>
      </div>
    )
  } else {
    return (
      <div className="meeting-details">
        <Loading />
      </div>
    )
  }
}

export default MeetingDetails
